import { render, staticRenderFns } from "./AutocompletePerson.vue?vue&type=template&id=4c377ea3"
import script from "./AutocompletePerson.vue?vue&type=script&lang=js"
export * from "./AutocompletePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports